import { useState } from "react";

export type PlanModalScenarios = "edit" | "download" | "delete" | "archive" | "unarchive";

export default function usePlanModalState() {
  const [modalScenario, setModalScenario] = useState<PlanModalScenarios | undefined>();

  return [
    modalScenario,
    (scenario: PlanModalScenarios | undefined) => setModalScenario(scenario === modalScenario ? undefined : scenario),
  ] as const;
}

export type PlanModalState = ReturnType<typeof usePlanModalState>;
